import { AsyncPipe } from "@angular/common";
import { Component } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { NxIconRegistry } from "@aposin/ng-aquila/icon";
import { TranslateService } from "@ngx-translate/core";
import { AuthSessionFacade } from "@services/auth-session/auth-session.facade";
import { HttpHelperService } from "@services/http-helper.service";

import { environment } from "../environments/environment";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { LoadingComponent } from "./shared/components/global/loading/loading.component";

@Component({
  selector: "app-root",
  standalone: true,
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  host: {
    "[class.login-route]": "isLoginRoute",
  },
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent,
    AsyncPipe,
    LoadingComponent,
  ],
})
export class AppComponent {
  protected user$ = this.authSessionFacade.user$;
  private readonly authRoutePrefixes = [
    "/login",
    "/secret-answer",
    "/first-time-login",
    "/reset-password",
    "/password-expired",
  ] as const;

  private readonly legacyNdbxIconNames = [
    "bars",
    "export-and-share",
    "filter",
    "search",
    "user-o",
    "xls",
  ] as const;

  protected get isLoginRoute(): boolean {
    return this.isAuthRoute(this.router.url);
  }

  protected get isLoginPage(): boolean {
    return this.isAuthRoute(this.router.url);
  }

  constructor(
    private readonly translate: TranslateService,
    private readonly httpHelperService: HttpHelperService,
    private readonly authSessionFacade: AuthSessionFacade,
    private readonly iconRegistry: NxIconRegistry,
    private readonly router: Router,
  ) {
    translate.setDefaultLang("en");
    this.httpHelperService.setEnv(environment.apiUrl);
    this.registerLegacyNdbxIcons();
  }

  private registerLegacyNdbxIcons(): void {
    const legacyFontName = "legacy-ndbx-font";
    this.iconRegistry.registerFont(legacyFontName, "ndbx-icon", "nx-icon--");

    for (const iconName of this.legacyNdbxIconNames) {
      this.iconRegistry.addFontIcon(iconName, undefined, legacyFontName);
    }
  }

  private isAuthRoute(url: string): boolean {
    return this.authRoutePrefixes.some((prefix) => url.startsWith(prefix));
  }
}
